const environments = {
  PUBLIC_URL: process.env.REACT_APP_PUBLIC_URL,
  CHAIN_ID: process.env.REACT_APP_CHAIN_ID,
  REACT_CHAIN_NAME: process.env.REACT_CHAIN_NAME,
  ENVIRONMENT: process.env.REACT_APP_ENVIRONMENT,
  VERSION_TARGET: process.env.REACT_APP_VERSION_TARGET,
  GAME_VERSION: process.env.REACT_APP_GAME_VERSION,
  FISH_BE_ENDPOINT: process.env.REACT_APP_FISH_BE_ENDPOINT,
  FISH_WEBSOCKET_ENDPOINT: process.env.REACT_APP_FISH_WEBSOCKET_ENDPOINT,
  CHAT_SOCKET_ENDPOINT: process.env.REACT_APP_CHAT_SOCKET_ENDPOINT,
  PUBLIC_RPC_URL: process.env.REACT_APP_RPC_BASE_SEPOLIA,
  CHEST_NFT_CONTRACT_ADDRESS: process.env.REACT_APP_CHEST_NFT_CONTRACT_ADDRESS,
  CHEST_FACTORY_CONTRACT_ADDRESS: process.env.REACT_APP_CHEST_FACTORY_CONTRACT_ADDRESS,
  ROD_NFT_CONTRACT_ADDRESS: process.env.REACT_APP_ROD_NFT_CONTRACT_ADDRESS,
  FISH_NFT_CONTRACT_ADDRESS: process.env.REACT_APP_FISH_NFT_CONTRACT_ADDRESS,
  FISH_FACTORY_CONTRACT_ADDRESS: process.env.REACT_APP_FISH_FACTORY_CONTRACT_ADDRESS,
  FISHING_GAME_CONTRACT_ADDRESS: process.env.REACT_APP_FISHING_GAME_CONTRACT_ADDRESS,
  DAILY_CHECKIN_CONTRACT_ADDRESS: process.env.REACT_APP_DAILY_CHECKIN_CONTRACT_ADDRESS,
  FRENZY_WALLET_CONTRACT_ADDRESS: process.env.REACT_APP_FRENZY_WALLET_CONTRACT_ADDRESS,
  FISHING_FRENZY_PURCHASE_GATEWAY_CONTRACT_ADDRESS:
    process.env.REACT_APP_FISHING_FRENZY_PURCHASE_GATEWAY_CONTRACT_ADDRESS,
  AQUARIUM_CONTRACT_ADDRESS: process.env.REACT_APP_AQUARIUM_CONTRACT_ADDRESS,
  STAKE_FISH_CONTRACT_ADDRESS: process.env.REACT_APP_STAKE_FISH_CONTRACT_ADDRESS,
  RPC_URL: process.env.REACT_APP_RPC_URL, // private/paid RPC (to avoid rate-limiting)
  SENTRY_DSN: process.env.REACT_APP_SENTRY_DSN,
  FISH_TOKEN_CONTRACT_ADDRESS: process.env.REACT_APP_FISH_TOKEN_CONTRACT_ADDRESS,
  XFISH_TOKEN_CONTRACT_ADDRESS: process.env.REACT_APP_XFISH_TOKEN_CONTRACT_ADDRESS,
  ROUTER_ADDRESS: process.env.REACT_APP_ROUTER_ADDRESS,
  USDC_ADDRESS: process.env.REACT_APP_USDC_ADDRESS,
  ROD_REPAIRER_CONTRACT_ADDRESS: process.env.REACT_APP_ROD_REPAIRER_CONTRACT_ADDRESS,
  SPIN_WHEEL_CONTRACT_ADDRESS: process.env.REACT_APP_SPIN_WHEEL_CONTRACT_ADDRESS,
  TOKEN_DASHBOARD_URL: process.env.REACT_APP_TOKEN_DASHBOARD_URL,
  TOKEN_DASHBOARD_BE_URL: process.env.REACT_APP_TOKEN_DASHBOARD_BE_URL,
  VRNG_API_URL: process.env.REACT_APP_VRNG_API_URL,
  VRF_COORDINATOR_CONTRACT_ADDRESS: process.env.REACT_APP_VRF_COORDINATOR_CONTRACT_ADDRESS,
};

export default environments;
